<template>
     <slot name="hero"></slot>
</template>

<script>
export default {

}
</script>

<style>

</style>